import React from 'react';
import PropTypes from 'prop-types';

import { currency } from 'utils/currency';
import { titleCase } from 'utils/strings';
import styles from './styles.module.scss';

const OrderSummary = ({ billingDate, items, orderTotal, shippingAddress }) => {
  const { firstName, lastName, address1, address2, city, state, zipCode } = shippingAddress;
  const fullName = `${firstName} ${lastName}`;
  const shipTo1 = `${titleCase(address1)} ${titleCase(address2) || ''}`;
  const shipTo2 = `${titleCase(city)}, ${state} ${zipCode}`;

  return (
    <div className={styles['order-summary']} data-testid="order-summary-container">
      <div>
        <h3>Ship To</h3>
        <p>
          <span data-testid="order-summary-full-name">{fullName}</span>
        </p>
        <p data-testid="order-summary-address1">{shipTo1}</p>
        <p data-testid="order-summary-address2">{shipTo2}</p>
      </div>
      <div className={styles.row}>
        <div>
          <h3>Items</h3>
          <p data-testid="order-summary-total-items">{items}</p>
        </div>
        <div>
          <h3>Total</h3>
          <p data-testid="order-summary-total">{currency.format(orderTotal)}</p>
        </div>
      </div>
    </div>
  );
};

OrderSummary.propTypes = {
  billingDate: PropTypes.string.isRequired,
  items: PropTypes.number.isRequired,
  orderTotal: PropTypes.number.isRequired,
  shippingAddress: PropTypes.shape({}).isRequired,
};

export default OrderSummary;
